module.exports = __webpack_public_path__ + "static/media/ROCKB.800bf3dd.TTF";